import Stack from "@mui/material/Stack"
import Typography from "@mui/material/Typography"
import { useState } from "react"

import DialogProvider from "@components/dialog_provider"
import { useWhatsappPageContext } from "@contexts/main/whatsapp_page_context"
import { deletePlatformMutation } from "@domain/whatsappApi"
import useControlledForm from "@hooks/use_controlled_form"
import { Box } from "@mui/material"
import CheckboxWrapper from "@pages/main/whatsapp_api/list/sub_components/whatsapp_data_table/sub_components/grid_checkbox"
import { useQueryClient } from "@tanstack/react-query"
import { showErrorToast } from "@utils/toast"
import { PlatformType } from "__generated__/graphql"
import { useNavigate } from "react-router-dom"

export default function DeleteWhatsappApi({
  isOpen,
  setClose,
  selectedRow,
  customerId
}: {
  isOpen: boolean
  setClose: () => void
  selectedRow?: string
  customerId?: string
}) {
  const queryClient = useQueryClient()
  const { translate } = useWhatsappPageContext()
  const [loading, setLoading] = useState(false)
  const [deleteConvdMsg, setDeleteConvMsg] = useState(false)

  const navigate = useNavigate()

  const {
    formState: { isValid }
  } = useControlledForm({
    mode: "all"
  })

  function handleClose() {
    if (loading) {
      return
    }
    setClose()
  }
  async function onSubmit() {
    if (selectedRow && customerId) {
      setLoading(true)
      const {
        isSuccess,
        errorMessage,
        data: responseData
      } = await deletePlatformMutation({
        metaData: {
          platformId: selectedRow,
          customerId: customerId,
          deleteConvAndMsg: deleteConvdMsg
        },
        type: PlatformType.WhatsAppBusiness
      })
      if (!isSuccess || !responseData) {
        setLoading(false)
        showErrorToast(String(errorMessage))
        return
      }

      queryClient.invalidateQueries({ queryKey: ["whatsapp-data-table"] })

      setLoading(false)
      navigate("/whatsapp")
    }
  }

  return (
    <DialogProvider
      title={translate("delete_whatsapp_api")}
      leftButton={{
        text: translate("cancel"),
        color: "secondary",
        onClick: handleClose,
        disabled: loading
      }}
      rightButton={{
        text: translate("delete"),
        color: "error",
        onClick: onSubmit,
        loading: loading,
        disabled: !isValid
      }}
      isOpen={isOpen}
      setClose={handleClose}
      size="small"
    >
      <Stack justifyContent={"center"} alignItems={"center"} flex={1} gap={4}>
        <Typography align="center">
          {translate("delete_whatsap_api_text")}
        </Typography>
        <Stack flexDirection={"row"} gap={2}>
          <Typography align="center">
            {translate("delete_conversations_and_messages")}
          </Typography>
          <Box mt={-1}>
            <CheckboxWrapper
              onChange={() => setDeleteConvMsg(!deleteConvdMsg)}
              checked={deleteConvdMsg}
            />
          </Box>
        </Stack>
      </Stack>
    </DialogProvider>
  )
}
